<!--<ion-header *ngIf="!device.isMobile()">-->
<!--  <ion-toolbar>-->
<!--&lt;!&ndash;    <ion-title color="primary"> {{ title || ("PUZZLE.welcome_dialog.title" | translate) }} </ion-title>&ndash;&gt;-->
<!--    <ion-title> {{("PUZZLE.welcome_dialog.title" | translate) }} </ion-title>-->
<!--  </ion-toolbar>-->
<!--</ion-header>-->

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-list>
          <ion-list-header *ngIf="title" lines="none">
            <ion-text color="primary">
              <h1 [innerHTML]="title"></h1>
            </ion-text>
          </ion-list-header>
          <ion-item *ngIf="compatibilityWarning" lines="none">
            <lib-app-puzzle-compatibillity-warning />
          </ion-item>
          <ion-item *ngIf="noLocalStorage" lines="none">
            <lib-app-puzzle-localstorage-warning />
          </ion-item>
          <ion-item *ngIf="showDesktopModeWarning" lines="none">
            <lib-app-puzzle-desktop-mode-warning />
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row [class.puzzle-modal-grow]="!showStartButtonInContent">
      <ion-col>
        <ion-item lines="none">
          <ion-text [innerHTML]="text" />
        </ion-item>
      </ion-col>
    </ion-row>
    <ng-container *ngIf="(leaderboard.leaderboardEnabled$ | async)">
      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-toggle class="leaderboard-checkbox"
                        [(ngModel)]="wantsLeaderboard"
                        (ionChange)="want_leaderboard()"
                        labelPlacement="end"
                        color="primary" slot="start">
              <span class="ion-text-wrap">
                {{ "PUZZLE.welcome_dialog.leaderboard.want_leaderboard" | translate }}
              </span>
            </ion-toggle>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="wantsLeaderboard">
        <ion-col>
          <ion-item lines="none">
            <p class="leaderboard-message">
              {{ "PUZZLE.welcome_dialog.leaderboard.wants_leaderboard" | translate }}
            </p>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="wantsLeaderboard">
        <ion-col>
          <ion-item lines="none">
            <ion-radio-group [(ngModel)]="strictRulesActive" class="horizontal-radio-group">
              <ion-item lines="none" class="ion-no-padding">
                <ion-radio [value]="false" labelPlacement="end">
                  {{ 'PUZZLE.welcome_dialog.leaderboard.relaxed' | translate }}
                  <span style="color: #C0C0C0">★★★</span>
                </ion-radio>
              </ion-item>
              <ion-item lines="none" class="ion-no-padding">
                <ion-radio [value]="true" labelPlacement="end">
                  {{ 'PUZZLE.welcome_dialog.leaderboard.strict' | translate }}
                  <span style="color: #FFD700">★★★</span>
                </ion-radio>
              </ion-item>
            </ion-radio-group>
          </ion-item>
          <ion-item lines="none">
            <div>
                <!--                <span [style]="strictRulesActive ? 'color: #FFD700' : 'color: #C0C0C0'">★ ★ ★</span>-->
                <ng-container *ngIf="strictRulesActive">
                  {{ "PUZZLE.welcome_dialog.leaderboard.strict_description" | translate }}
                </ng-container>
                <ng-container *ngIf="!strictRulesActive">
                  {{ "PUZZLE.welcome_dialog.leaderboard.relaxed_description" | translate }}
                </ng-container>
                <span
                  class="consent-info"
                  (click)="showLeaderboardTooltip($event)"
                >
                  <ion-icon name="information-circle-sharp" color="primary"></ion-icon>
                </span>
                <p class="leaderboard-message">
                  {{ leaderboardDialogMessage }}
                </p>
              </div>
          </ion-item>
        </ion-col>
      </ion-row>
    </ng-container>

    <ion-row *ngIf="requestConsent">
      <ion-col>
        <ion-item lines="none">
          <ion-checkbox
            class="consent-checkbox"
            [(ngModel)]="consent"
            color="primary"
            labelPlacement="end"
            slot="start"
          >
            <span class="ion-text-wrap">
              <ng-container *ngIf="analytics.enabled">
                {{ "PUZZLE.welcome_dialog.analytics_consent_message.text_with_analytics" | translate }}
              </ng-container>
              <ng-container *ngIf="!analytics.enabled">
                {{ "PUZZLE.welcome_dialog.analytics_consent_message.text_without_analytics" | translate }}
              </ng-container>
            </span>
            <span
              *ngIf="analytics.enabled"
              class="consent-info"
              [tooltip]="'PUZZLE.welcome_dialog.analytics_consent_message.tooltip_with_analytics' | translate"
              placement="top"
              (click)="showPrivacyTooltip($event)"
            >
              <ion-icon name="information-circle-sharp" color="primary" />
            </span>
            <span
              *ngIf="!analytics.enabled"
              class="consent-info"
              [tooltip]="'PUZZLE.welcome_dialog.analytics_consent_message.tooltip_without_analytics' | translate"
              placement="top"
              (click)="showPrivacyTooltip($event)"
            >
              <ion-icon name="information-circle-sharp" color="primary" />
            </span>
            <p class="leaderboard-message">
              {{ "PUZZLE.welcome_dialog.privacy_policy.text" | translate }}
              <a
                class="privacy-policy-link"
                [href]="privacyUrl"
                target="_blank"
                (click)="showPrivacyDialog($event)"
              >
                {{ "PUZZLE.welcome_dialog.privacy_policy.link" | translate }}
              </a>
            </p>
          </ion-checkbox>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <lib-app-puzzle-changer-form
            [hideApplyButton]="true"
            class="puzzle-changer-form"
            (applyCallback)="saveApplyCallback($event)"
          />
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="updateNotifications.hasUpdates">
      <ion-col>
        <ion-item lines="none">
          <ion-icon
            name="bulb-outline"
            [size]="helperFunctions.isMobileDevice() ? 'large':'small'"
            color="primary"
            style="padding-right: 10px;"
          />
          <ion-text>
            {{ "PUZZLE.update_notification_modal.welcome_dialog.text" | translate }}
            <a
              class="privacy-policy-link"
              (click)="showUpdateNotificationDialog($event)"
            >
              {{ "PUZZLE.update_notification_modal.welcome_dialog.link" | translate }}
            </a>
          </ion-text>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="showStartButtonInContent">
      <ion-col>
          <div class="puzzle-modal-buttons">
          <ion-button color="primary" *ngIf="!apply" (click)="closeDialog()" [disabled]="!consent" fill="solid">
            <span *ngIf="started"> {{ "PUZZLE.welcome_dialog.continue_button" | translate }}</span>
            <span *ngIf="!started"> {{ "PUZZLE.welcome_dialog.start_button" | translate }}</span>
            <ion-icon slot="end" name="play-sharp"></ion-icon>
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>
<ion-footer *ngIf="!showStartButtonInContent">
  <div class="puzzle-modal-buttons">
    <ion-button color="primary" *ngIf="!apply" (click)="closeDialog()" [disabled]="!consent" fill="solid">
      <span *ngIf="started"> {{ "PUZZLE.welcome_dialog.continue_button" | translate }}</span>
      <span *ngIf="!started"> {{ "PUZZLE.welcome_dialog.start_button" | translate }}</span>
      <ion-icon slot="end" name="play-sharp"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
